<template>
  <div class="login-wrap">
    <v-header v-if="$route.path != '/login'" />
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import vHeader from "@/components/header.vue";
export default {
  name: '',

  data () {
    return {
      isLogin: false
    }
  },
  components: {
    'v-header': vHeader
  },

  methods: {}
}
</script>

<style lang='scss' scoped>
.login-wrap {
  min-width: 1139px;

}
</style>
